import { APP_CONFIG } from '../config';
import {
    FETCH_REQUEST, FetchRequestAction
} from '../middleware';
import { SessionsPOSTResponse } from '@api';

export const AUTH_STATE_NAME = 'auth';

type Params = {
    env?: string
    productId?: number
    userName: string
    password: string
};

export const fetchPostSessionsRequest = ({
    userName,
    password,
    productId,
    env = 'live'
}: Params): FetchRequestAction<SessionsPOSTResponse> => {
    productId = productId ?? 1;
    const resolveUrl = () => {
        const url: string = APP_CONFIG.authenticationGateway[env];

        return url;
    };

    return {
        type: FETCH_REQUEST,
        payload: {
            name: AUTH_STATE_NAME,
            resolveUrl,
            body: JSON.stringify({
                userName,
                password,
                productId
            }),
            method: 'POST'
        }
    };
};
